import { render, staticRenderFns } from "./SummaryItem.vue?vue&type=template&id=185e32da&scoped=true"
import script from "./SummaryItem.ts?vue&type=script&lang=ts&external"
export * from "./SummaryItem.ts?vue&type=script&lang=ts&external"
import style0 from "./SummaryItem.vue?vue&type=style&index=0&id=185e32da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e32da",
  null
  
)

export default component.exports